import { render, staticRenderFns } from "./fccGestaoCadastrosTipoEndereco.vue?vue&type=template&id=37fa2306"
import script from "./fccGestaoCadastrosTipoEndereco.vue?vue&type=script&lang=js"
export * from "./fccGestaoCadastrosTipoEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports